export const LOAD_STARTED = 'ONBOARDING_QUEUE/LOAD_STARTED';
export const VIEW_LOADED = 'ONBOARDING_QUEUE/VIEW_LOADED';
export const VIEW_FAILED = 'ONBOARDING_QUEUE/VIEW_FAILED';
export const LOAD_FINISHED = 'ONBOARDING_QUEUE/LOAD_FINISHED';
export const RESET = 'ONBOARDING_QUEUE/RESET';
